import React from 'react';
import {Button} from 'react-native-elements';
import styles from '../style/common';

export default props => {
    return <Button {...props} type='clear' titleStyle={styles.white} />;
};
